import React, { useMemo } from 'react';

import _ from 'lodash';
import { Flex } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { WidgetStatistic } from 'src/pages/dashboard/styles';
import useOccurrences from 'src/pages/dashboard/contexts/useOccurrences';
import {
	CardTitle,
	CardData,
	IconArea
} from 'src/pages/dashboard/components/cards/styles';

export default function SeverityWithMostOccurrences() {
	const { occurrences, } = useOccurrences();

	const data = useMemo(() => {
		const alertOccurrences = occurrences.filter(occ => !occ.is_recovery);

		const groupedBySeverity = _.groupBy(alertOccurrences, (occurrence) => 
			occurrence.observer.severity.name
		);

		const severityCounts = _.mapValues(groupedBySeverity, (group) => 
			group.length
		);

		const maxSeverityName = _.maxBy(Object.keys(severityCounts), (severity) => 
			severityCounts[severity]
		);

		if(!maxSeverityName){
			return {
				name: '',
				count: 0,
			};
		}

		return {
			name: maxSeverityName,
			count: severityCounts[maxSeverityName],
		};
	}, [ occurrences, ]);

	return (
		<Flex
			gap={16}
			justify='space-between'
			style={{ width: '100%', }}
		>
			<Flex vertical gap={4}>
				<CardTitle>
                    Severidade com mais ocorrências:
				</CardTitle>
				<CardData>
					<span>{data.name}</span>
					<WidgetStatistic>
						{data.count}
					</WidgetStatistic>
				</CardData>
			</Flex>
			<IconArea>
				<WarningOutlined style={{ fontSize: 24, color: '#fff', }} />
			</IconArea>
		</Flex>
	);
}
